import React from "react";

export default function Footer(){
    
    const links = [
        {name: "About", 
          path: "",
        },
        {
          name: "Contact",
          path: "",
        },
        {
            name: "Waitlist",
            path: ""
        }
    ]
    
    
    return(
     <div className="bg-custom-purple mt-10 flex">
      <div>
        <h1 translate="no" className=" bg-gradient-to-r from-purple-600 to-pink-500 text-3xl font-bold bg-clip-text text-transparent">Storii</h1>
        <p className="text-gray-400">Diffrent stories for everyone . . .</p>
      </div>
      <div className="ml-auto mt-auto p-4">
        <ul className="flex space-x-4">
        {links.map((link, index) => 
            
            <li key={link.index} className="text-white space-x-4">{link.name}</li>
            
        )}
        </ul>
      </div>
     </div>
    );
}